import { render, staticRenderFns } from "./ApproveDocumentBtn.vue?vue&type=template&id=3e2843ab&"
import script from "./ApproveDocumentBtn.vue?vue&type=script&lang=ts&"
export * from "./ApproveDocumentBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports